module.exports = __webpack_public_path__ + "img/20200801_161404.8b345710.jpg";